import React from 'react';
import styles from './styles.sass';

const InfoButtonIcon = ({ className = '', onClick = () => {} }) => (
  <span onClick={onClick} className={`${styles.infoButton} ${className}`}>
    i
  </span>
);

export default InfoButtonIcon;
